// new poller to place orders in API directly
import Poller from '../../../modules/Poller';
import orderStatusPollerFailed from '../pollerHandlers/orderStatusPollerFailed';
// eslint-disable-next-line import/no-cycle
import orderStatusPollerSuccess from '../pollerHandlers/orderStatusPollerSuccess';
import paymentChangePollerFailed from '../pollerHandlers/paymentChangePollerFailed';
import paymentResolutionPollerFailed from '../pollerHandlers/paymentResolutionPollerFailed';
import PromisePoller from '../PromisePoller/PromisePoller';

export const placeOrderViaApiPoller = new Poller({
  postURL: '/checkout-api/v2/order/place-order',
  pollURL: '/checkout-api/v2/order/status',
}, orderStatusPollerSuccess, orderStatusPollerFailed);

export const placeOrderViaApiKlarnaPoller = new Poller({
  postURL: '/checkout-api/v2/order/place-order',
  pollURL: '/checkout-api/v2/order/placement-status',
}, orderStatusPollerSuccess, orderStatusPollerFailed);

// new poller to place orders in API directly
export const resolvePaymentViaApiPoller = new Poller({
  postURL: '/checkout-api/v2/order/resolve-payment',
  pollURL: '/checkout-api/v2/order/status',
}, orderStatusPollerSuccess, paymentResolutionPollerFailed);

export const paymentChangeWithApiPoller = new Poller({
  postURL: '/checkout-api/v2/order/change-payment',
  pollURL: '/checkout-api/v2/order/status',
}, orderStatusPollerSuccess, paymentChangePollerFailed);

// --- Returned from Paypal poller ---
export const paypalStatusPoller = new Poller({
  postURL: '/checkout-api/v2/return-from-hosted/paypal',
  pollURL: '/checkout-api/v2/order/status',
}, orderStatusPollerSuccess, orderStatusPollerFailed);

// --- Returned from Klarna poller ---
export const klarnaReturnStatusPoller = new Poller({
  postURL: '/checkout-api/v2/return-from-hosted/klarna',
  pollURL: '/checkout-api/v2/order/status',
}, orderStatusPollerSuccess, orderStatusPollerFailed);

// --- Returned from Adyen poller ---
export const adyenStatusPoller = new Poller({
  postURL: '/checkout-api/v2/return-from-hosted/adyen',
  pollURL: '/checkout-api/v2/order/status',
}, orderStatusPollerSuccess, orderStatusPollerFailed);

export const resolvePaymentAdyenStatusPoller = new Poller({
  postURL: '/checkout-api/v2/return-from-hosted/adyen',
  pollURL: '/checkout-api/v2/order/status',
}, orderStatusPollerSuccess, paymentResolutionPollerFailed);

export const afterPayStatusPoller = new Poller({
  postURL: '/checkout-api/v2/return-from-hosted/afterpay',
  pollURL: '/checkout-api/v2/order/status',
}, orderStatusPollerSuccess, orderStatusPollerFailed);

export const kcpStatusPoller = new Poller({
  postURL: '/checkout-api/v2/return-from-hosted/kcp',
  pollURL: '/checkout-api/v2/order/status',
}, orderStatusPollerSuccess, orderStatusPollerFailed);

export const deliveryOptionsPoller = new PromisePoller(
  '/checkout-api/v2/delivery',
  '/checkout-api/v2/delivery',
  null,
  true,
);

export const paypalExpressTokenPoller = new PromisePoller(
  '/checkout-api/v2/express/paypal/generateToken',
  '/checkout-api/v2/order/status',
);

export const orderStatusPromisePoller = new PromisePoller(
  null,
  '/checkout-api/v2/order/status',
);
